export const parseRGBList = ([red, green, blue]: RGBValuesList): string =>
    `rgb(${red},${green},${blue})`;
